import React from 'react';
import { useNavigate } from 'react-router-dom';
import LexyAppShell from '../components/LexyAppShell';
import AINextSteps from '../components/AINextSteps';

const AINextStepsPage = () => {
  const navigate = useNavigate();

  return (
    <LexyAppShell activeView="ai-next-steps">
      <div className="max-w-7xl mx-auto p-4 sm:p-6 lg:p-8">
        <AINextSteps 
          compact={false}
          onNavigate={(url) => navigate(url)}
        />
      </div>
    </LexyAppShell>
  );
};

export default AINextStepsPage;
